import { Component, OnInit, HostBinding, ElementRef, inject } from "@angular/core";
import { CardComponent } from "../card/card.component";
import { CardFooterComponent } from "../card-footer/card-footer.component";
import { CardBodyComponent } from "../card-body/card-body.component";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "[avInput]",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
  standalone: false,
})
export class InputComponent implements OnInit {
  host = inject<ElementRef<HTMLInputElement | HTMLTextAreaElement>>(ElementRef);
  private card = inject(CardComponent, { optional: true });
  private cardBody = inject(CardBodyComponent, { optional: true });
  private cardFooter = inject(CardFooterComponent, { optional: true });


  @HostBinding("class") get class() {
    return {
      "av-input-card": this.isInCard,
    };
  }

  ngOnInit(): void {}

  get nativeElement(): HTMLInputElement | HTMLTextAreaElement {
    return this.host.nativeElement;
  }

  get isInCard() {
    return (
      (this.card && this.card.type() === "container") ||
      (this.cardBody && this.cardBody.type() === "spotlight") ||
      (this.cardFooter && this.cardFooter.type === "container")
    );
  }
}
